<template>
  <div id="landing-page">
    <div class="hero-body">
      <h1 class="title is-size-1">Get Playing!</h1>
      <h2 class="subtitle is-size-3">Using 'digital' money makes a big difference when playing monopoly.</h2>
    </div>
    <div id="signin"></div>
  </div>
</template>

<script>
import { signInUi } from "@/firebase";
import { firebase } from "@/firebase";
import router from "../router";

export default {
  mounted: function () {
    console.log("Mounted SignIn Page");
    var uiConfig = {
      // TODO Find out how to generate links
      signInSuccessUrl: "/home",
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: []
        },
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      signInFlow: "popup",
      // Terms of service url.
      tosUrl: "/tos",
      privacyPolicyUrl: "/privacy",
    };
    // The start method will wait until the DOM is loaded.
    signInUi.start("#signin", uiConfig);

    firebase.auth().onAuthStateChanged((user) => {
      console.log("FIRST : Auth State Changed", user);
      const currentUser = firebase.auth().currentUser;
      console.log("FIRST: Current User", currentUser)
      if (user) {
        router.replace({ path: "home" });
      } else {
        router.push({ path: "signin" });
      }
    });
  },
  computed: {
    width: function () {
      let w = window.innerWidth;
      if (w < 600) {
        return w - 100;
      } else {
        return w - 800;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#signin {
  display: inline-block;
}
#landing-page {
  text-align: center;
}
</style>